import { render, staticRenderFns } from "./MaterialFolderEditDialog.vue?vue&type=template&id=8b51522c&scoped=true"
import script from "./MaterialFolderEditDialog.vue?vue&type=script&lang=ts"
export * from "./MaterialFolderEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./MaterialFolderEditDialog.vue?vue&type=style&index=0&id=8b51522c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b51522c",
  null
  
)

export default component.exports